import React, { useState, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";
import tw from "twin.macro";
import HeaderContainer from "./ScaldComponets/WarehouseAccountingHeader";
import { ReactComponent as SearchIcon } from "../../images/img/search-icon.svg";
import { FaPrint } from "react-icons/fa";

import Sidebar from "./ScaldComponets/Sidebar";
import JsBarcode from "jsbarcode";
import { collection, getDocs } from "firebase/firestore";
import { db } from '../../FireBaseConfig';

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'SFUIText';
        font-weight: 300;
        font-style: normal;
    }

    body, html {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'SFUIText', sans-serif;
    }
`;

const Container = styled.div`
    ${tw`min-h-screen`}
    display: flex;
    flex-direction: column;
`;

const MainContent = styled.div`
    ${tw`flex flex-col lg:flex-row`}
    flex-grow: 1;
`;

const Content = styled.div`
    ${tw`flex-grow p-8`}
    display: flex;
    flex-direction: column;
`;

const Heading = styled.h1`
    ${tw`text-green-1002 font-semibold text-xl`}
`;

const Divider = styled.div`
    ${tw`bg-gray-300`}
    height: 1px;
    width: 100%;
    margin: 20px 0;
`;

const Form = styled.div`
    ${tw`flex items-center space-x-6`}
    gap: 1rem;
`;

const InputContainer = styled.div`
    ${tw`flex flex-col relative items-center`}
    flex: 1;
`;

const SearchInput = styled.input`
    ${tw`rounded-lg p-3 w-full text-gray-600 mt-4 pl-10`};
    border: 1px solid #d3d3d3; /* Легкая серая граница */
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
    font-size: 16px;
    transition: all 0.3s ease;
    width: 96%;
    &:focus {
        border-color: #0ABD19;
        box-shadow: 0 0 6px rgba(10, 189, 25, 0.5); /* Подсветка при фокусе */
        outline: none;
    }

    &::placeholder {
        color: #b0b0b0; /* Более светлый текст для placeholder */
        font-style: italic; /* Курсив для текстового подсказки */
    }

    &:hover {
        border-color: #0ABD19; /* Легкий акцент на hover */
    }
`;

const SearchIconContainer = styled.div`
    ${tw`absolute inset-y-0 left-0 flex items-center mt-4`}
    pointer-events: none;
    padding-left: 24px;
`;

const SearchButton = styled.button`
    ${tw`rounded-lg px-6 py-3 text-white font-medium ml-2`}
    background-color: #0ABD19;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 16px;

    &:hover {
        background-color: #0ABD50;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.98);
    }
`;

const InfoText = styled.p`
    ${tw`text-gray-600 text-base items-start ml-2 font-bold`}
    color: #999999;
`;

const LabelsContainer = styled.div`
    ${tw`grid gap-0`};
    grid-template-columns: 1fr 1fr 1fr 1.5fr 2fr 0.7fr 1fr; /* Разная ширина столбцов */
    background-color: #f3f4f6;
    font-weight: bold;
    color: #374151;
    border-bottom: 2px solid #000000;
    border: 2px solid #000000; /* Внешняя рамка */
    text-align: center;
`;

const DataGrid = styled.div`
    ${tw`grid gap-0`};
    margin-top: 10px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1.5fr 2fr 0.7fr 1fr; /* Разная ширина столбцов */
    width: 100%;
    border: 2px solid #000000; /* Внешняя рамка */
`;
const DataCell = styled.div`
    ${tw`p-3 text-sm`};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ index }) => (index % 2 === 0 ? '#ffffff' : '#f9fafb')}; /* Чередование строк */
    color: #4b5563; /* Серый текст */
    border-bottom: 2px solid #000000; /* Черный разделитель строк */
    border-right: 2px solid #000000; /* Вертикальные черные линии */
    text-align: center;

    &:last-child {
        border-right: none; /* Убираем правую границу у последней ячейки в строке */
    }

    &:hover {
        background-color: #f0f9ff; /* Легкий акцент на hover */
        cursor: pointer;
    }
`;
const CellLabel = styled.span`
    ${tw`font-semibold text-sm`};
    color: #000000;
    display: block;
    width: 100%;
    text-align: center;
    padding: 12px;
    border-right: 2px solid #000000; /* Вертикальные черные линии */

    &:last-child {
        border-right: none; /* Убираем правую границу у последнего заголовка */
    }
`;

const PrintIcon = styled.img`
    ${tw`w-6 h-6 cursor-pointer`};
    filter: grayscale(100%);
    transition: all 0.2s ease;

    &:hover {
        filter: grayscale(0%);
        transform: scale(1.1); /* Увеличение при наведении */
    }
`;

const EditButton = styled.button`
    ${tw`px-4 py-2 text-white rounded-lg font-medium`}
    background-color: #0ABD19;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 13px;

    &:hover {
        background-color: #0ABD50;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.98);
    }
`;
const ExpectedParcelsPage = () => {
    const [parcels, setParcels] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [filteredParcels, setFilteredParcels] = useState([]);
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [statusFilter, setStatusFilter] = useState("all");
    const uniqueStatuses = Array.from(new Set(parcels.map(p => p.status).filter(Boolean)));

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };

    const getSortedData = () => {
        const data = [...filteredParcels];
        if (!sortField) return data;

        return data.sort((a, b) => {
            const valA = a[sortField] || "";
            const valB = b[sortField] || "";

            if (sortOrder === "asc") {
                return valA.localeCompare(valB);
            } else {
                return valB.localeCompare(valA);
            }
        });
    };

    const sortedParcels = getSortedData();

    useEffect(() => {
        const fetchParcels = async () => {
            const querySnapshot = await getDocs(collection(db, "parcels"));
            const parcelsData = querySnapshot.docs.map(doc => doc.data());
            setParcels(parcelsData);
            setFilteredParcels(parcelsData); // Initialize filtered data
        };

        fetchParcels();
    }, []);

    const handleSearch = () => {
        setSearchQuery(searchInput);
    };

    useEffect(() => {
        const filtered = parcels.filter(parcel =>
            parcel.trackingNumber?.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (statusFilter === "all" || parcel.status === statusFilter)
        );
        setFilteredParcels(filtered);
    }, [searchQuery, statusFilter, parcels]);


    const printParcel = (parcel) => {
        const printWindow = window.open("", "_blank");
        if (printWindow) {
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Print Parcel</title>
                        <style>
                            body { font-family: Arial, sans-serif; padding: 20px; }
                            h1 { font-weight: bold; }
                            svg { margin-top: 10px; }
                        </style>
                    </head>
                    <body>
                        <h1>EPARCEL</h1>
                        <p>Date: ${parcel.dateReceived || "N/A"}</p>
                        <p>Client ID: ${parcel.userId || "N/A"}</p>
                        <p>Tracking Number: ${parcel.trackingNumber || "N/A"}</p>
                        <svg id="barcode"></svg>
                    </body>
                </html>
            `);

            printWindow.document.close();

            const barcodeSvg = printWindow.document.getElementById("barcode");
            if (barcodeSvg) {
                JsBarcode(barcodeSvg, parcel.trackingNumber || "N/A", {
                    format: "CODE128",
                    displayValue: true,
                    lineColor: "#000",
                    width: 2,
                    height: 50,
                });
            }

            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }
    };
    return (
        <Container>
            <GlobalStyle />
            <HeaderContainer />
            <MainContent>
                <Sidebar />
                <Content>
                    <Heading>Входящие посылки</Heading>
                    <Divider />
                    <Form>
                        <InputContainer>
                            <SearchIconContainer>
                                <SearchIcon />
                            </SearchIconContainer>
                            <SearchInput
                                type="text"
                                placeholder="Поиск по трекинг-номеру"
                                value={searchInput}
                                onChange={e => setSearchInput(e.target.value)}
                                onKeyPress={e => e.key === 'Enter' && handleSearch()}
                            />
                        </InputContainer>
                        <SearchButton onClick={handleSearch}>Поиск</SearchButton>
                        <select
                            value={statusFilter}
                            onChange={e => setStatusFilter(e.target.value)}
                            style={{
                                padding: '0.5rem',
                                borderRadius: '0.5rem',
                                border: '1px solid #d3d3d3',
                                marginTop: '1rem',
                                height: '42px',
                                fontSize: '14px'
                            }}
                        >
                            <option value="all">Все статусы</option>
                            {uniqueStatuses.map(status => (
                                <option key={status} value={status}>{status}</option>
                            ))}
                        </select>

                    </Form>
                    <InfoText>Общее количество посылок: {filteredParcels.length}</InfoText>
                    <LabelsContainer>
                        <CellLabel>Shelf no</CellLabel>
                        <CellLabel>№ заявки</CellLabel>
                        <CellLabel
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleSort("dateReceived")}
                        >
                            Дата приема {sortField === "dateReceived" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
                        </CellLabel>
                        <CellLabel>ID клиента</CellLabel>
                        <CellLabel>Tracking ID</CellLabel>
                        <CellLabel>Печать</CellLabel>
                        <CellLabel>Действия</CellLabel>
                    </LabelsContainer>

                    <DataGrid>
                        {sortedParcels.map((parcel, index) => (

                            <React.Fragment key={index}>
                                <DataCell>
                                    {parcel.shelfNumber || "Еще не обработана"}
                                </DataCell>
                                <DataCell>
                                    {parcel.id}
                                    <br />
                                    {parcel.status}
                                </DataCell>
                                <DataCell>
                                    {parcel.dateReceived || "Еще нет"}
                                </DataCell>
                                <DataCell>
                                    {parcel.userId}
                                </DataCell>
                                <DataCell>
                                    {parcel.trackingNumber || "N/A"}
                                </DataCell>
                                <DataCell>
                                    <FaPrint
                                        alt="Print"
                                        onClick={() => printParcel(parcel)}
                                    />
                                </DataCell>
                                <DataCell>
                                    <EditButton onClick={() => (window.location.href = `/EditingParcel/${parcel.id}`)}>
                                        Изменить
                                    </EditButton>
                                </DataCell>
                            </React.Fragment>
                        ))}
                    </DataGrid>
                </Content>
            </MainContent>
        </Container>
    );
};

export default ExpectedParcelsPage;
